import { Component, OnInit } from "@angular/core";

export const LOGGED_IN = 'logged in';

@Component({
    template: '<h1>Redirecting... Please wait</h1>'
})
export class OidcCallbackComponent implements OnInit {
    ngOnInit(): void {
        window.parent.postMessage(LOGGED_IN);
    }
}